<template lang="pug">
.v-not-found.not-found(v-if="data")
	.container
		.not-found__content
			.not-found__title(v-if="data.title" ) {{ data.title }}
			img.not-found__image(v-if="data.image"
					:src="data.image?.src"
					:alt="data.image?.alt")
			a.not-found__link(v-if="data.link"
					:href="data.link?.href"
					:class="data.link?.className")
					| {{ data.link.text }}

</template>


<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import formattingMixin from "components/mixins/v-mixin-formatting.vue";
import isMobMixin from "components/mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		sourceMixin,
	],

	data() {
		return {
			data: null,
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	},

}
</script>